import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { Router, Route, IndexRoute, browserHistory } from 'react-router';
import { setPolifills } from './utils/polyfills';
import ReactGA from 'react-ga';

import './assets/styles/main.scss';

import App from './components/App';
import Homepage from './components/Homepage';
import SearchBookings from './components/SearchBookings';
import Register from './components/Register';
import MyAccount from './components/MyAccount';
import ResetPassword from './components/ResetPassword';
import UserIsAuthenticated from './security/UserIsAuthenticated';
import BookingHistory from './components/BookingHistory';
import FAQ from './components/FAQ';

import store from './store';
import Credentials from './components/account/Credentials';
import SearchBookingsSolo from './components/SearchBookingsSolo';
import PersonalDetails from './components/account/PersonalDetails';
import DrivingLicence from './components/account/DrivingLicence';
import IdentityDocument from './components/account/IdentityDocument';
import Selfie from './components/account/Selfie';
import MoreInfo from './components/account/MoreInfo';
import SwitchProfile from './components/account/SwitchProfile';
import PaymentInfo from './components/account/PaymentInfo';
import Notifications from './components/account/Notifications';
import SearchEditBookings from './components/SearchEditBookings';
import Redirect from './components/Redirect';
import ProfileLanguage from './components/account/ProfileLanguage';
import WelcomeMessage from './components/WelcomeMessage';
import ForcePasswordUpdate from './components/ForcePasswordUpdate';

setPolifills();

function logPageView() {
  ReactGA.set({ page: window.location.pathname });
  ReactGA.pageview(window.location.pathname);
}

const setLocale = (props) =>
  props.children &&
  React.cloneElement(props.children, {
    i18n: props.i18n
  });

function runApp() {
  const Authenticated = UserIsAuthenticated(setLocale);

  ReactGA.initialize('UA-87106237-1');

  ReactDOM.render(
    <Provider store={store}>
      <Router history={browserHistory} onUpdate={logPageView}>
        <Route path="/" component={App}>
          <IndexRoute component={Homepage} />
          <Route path="/search-bookings" component={SearchBookingsSolo} />
          <Route component={Authenticated}>
            <Route component={MyAccount} path="profile">
              <Route path="/profile/credentials" component={Credentials} />
              <Route path="/profile/personal-info" component={PersonalDetails} />
              <Route path="/profile/driver-license" component={DrivingLicence} />
              <Route path="/profile/identity-document" component={IdentityDocument} />
              <Route path="/profile/selfie" component={Selfie} />
              <Route path="/profile/payment" component={PaymentInfo} />
              <Route path="/profile/language" component={ProfileLanguage} />
              <Route path="/profile/notifications" component={Notifications} />
              <Route path="/profile/additional-info" component={MoreInfo} />
              <Route path="/profile/switch" component={SwitchProfile} />
              <Route path="/profile/technician-access" />
            </Route>
            <Route path="/password-update" component={ForcePasswordUpdate} />
            <Route path="/welcome-message" component={WelcomeMessage} />
            <Route path="my-bookings" component={BookingHistory} />
            <Route path="mes-reservations" component={Redirect} />
            <Route path="redirect" component={Redirect} />
          </Route>
          <Route path="edit-booking" component={SearchEditBookings} />
          <Route path="book?*" component={SearchBookings} />
          <Route path="book" component={SearchBookings} />
          <Route path="reserver" component={Redirect} />
          <Route path="create-booking" component={SearchBookings} />
          <Route path="creation/:id" component={Register} />
          <Route path="reset-password/:token" component={ResetPassword} />
          <Route path="contactez-nous" component={Redirect} />
          <Route path="validate-account/:token" component={Homepage} />
          <Route path="faq" component={FAQ} />
        </Route>
      </Router>
    </Provider>,
    document.getElementById('root')
  );
}

if (!window.Intl) {
  require.ensure([], () => {
    require('intl');
    runApp();
  });
} else {
  runApp();
}



/** WEBPACK FOOTER **
 ** ./src/index.js
 **/